import { customAxios } from "./customAxios"
export function assignTo(idMonitoraggio, username) {
    const config = {
        headers: {
            Authtoken: JSON.parse(localStorage.getItem('token')),
            'Content-Type': 'application/json'
        }
    }

    const data = JSON.stringify({
        "idMonitoraggio": idMonitoraggio,
        "username": username
    })
    const searchRequest = customAxios.post(process.env.REACT_APP_BACKEND_HOST + "/adv/monitoraggio/assign-to", data, config)
    return searchRequest
}